import React from "react";
import { Container } from "./styles";

interface CardProps {
  variant?: string;
  children: React.ReactNode;
  ref?: any;
}
export default function Card({ variant, children, ref }: CardProps) {
  return (
    <Container
      // @ts-ignore
      variant={ variant }
      ref={ref}
    >
      {children}
    </Container>
  );
}
